import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import actionTypes from "./actionTypes";
export const initialState = {
    panelWidth: undefined
};
export default createReducer(initialState, {
    [actionTypes.SET_PANEL_WIDTH]: (state, { width }) => set(state, "panelWidth", width)
});
